import { commandBus } from '@/features/chat'
import { useStudioStore } from '@/store/studio-store'
import { useStudioLocale } from '@/i18n'
import { getDataSurfaceCopy } from '../../data-surface-copy'
import type { EventEntity } from '../../hooks/use-entity-index'

function selectEventEntity(e: EventEntity) {
  commandBus.dispatch({
    type: 'selectEntity',
    payload: { blockName: e.blockName, category: 'events', name: e.eventKey },
  })
  useStudioStore.getState().selectEntity(e.id)
}

export function EventTable({ events }: { events: EventEntity[] }) {
  const { locale, strings } = useStudioLocale()
  const copy = getDataSurfaceCopy(locale)
  const fields = strings.dataInspector.fields
  if (events.length === 0) {
    return <p className="text-xs text-muted-foreground p-4">{copy.emptyTitle.events}</p>
  }

  return (
    <table className="w-full text-xs">
      <thead>
        <tr className="border-b border-border text-left text-muted-foreground">
          <th className="px-3 py-2 font-medium">{fields.block}</th>
          <th className="px-3 py-2 font-medium">{fields.component}</th>
          <th className="px-3 py-2 font-medium">{fields.event}</th>
          <th className="px-3 py-2 font-medium">{fields.flow}</th>
        </tr>
      </thead>
      <tbody>
        {events.map((e) => (
          <tr
            key={e.id}
            className="border-b border-border/50 hover:bg-accent/50 cursor-pointer transition-colors"
            onClick={() => selectEventEntity(e)}
          >
            <td className="px-3 py-1.5 text-muted-foreground">{e.blockName}</td>
            <td className="px-3 py-1.5 font-mono">{e.componentId}</td>
            <td className="px-3 py-1.5">{e.eventType}</td>
            <td className="px-3 py-1.5 font-mono text-primary">{e.boundFlow ?? 'unbound'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
